'use client'

import { useEffect } from 'react'
import { sendErrorLog } from '~/libs/datadog'
import { stripQuery } from '~/libs/url'

const TRACKED_TAGS = ['img', 'track', 'video', 'source']

export const ResourceErrorReporter = () => {
  useEffect(() => {
    const probe = document.createElement('video')

    const handleError = (event: Event) => {
      const target = event.target
      if (!(target instanceof HTMLElement)) return

      const tag = target.tagName.toLowerCase()
      if (!TRACKED_TAGS.includes(tag)) return

      if (tag === 'source') {
        const type = target.getAttribute('type')
        if (type && !probe.canPlayType(type)) return
      }

      const src =
        (target instanceof HTMLImageElement && target.currentSrc) || target.getAttribute('src')
      if (!src) return

      const url = stripQuery(src)
      if (!url) return

      if (url.origin !== window.location.origin && !url.hostname.endsWith('.cloudfront.net')) return

      sendErrorLog(new Error(`Resource load failed: ${tag}`), { tag, url: url.href })
    }

    window.addEventListener('error', handleError, true)
    return () => window.removeEventListener('error', handleError, true)
  }, [])

  return null
}
